var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.customerType.type !== "examine",
              expression: "customerType.type !== 'examine'",
            },
          ],
          staticStyle: { height: "50px" },
        },
        [
          _c(
            "el-button",
            {
              staticStyle: { float: "right" },
              attrs: { icon: "el-icon-plus", plain: "" },
              on: {
                click: function ($event) {
                  _vm.clickSenderDialog(
                    _vm.$t("customerManagements.createConsignee"),
                    null
                  )
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("GlobalSetObj.create")) + " ")]
          ),
        ],
        1
      ),
      _c("div", { staticClass: "addressClass" }, [
        _vm.customerAddressList.length > 0
          ? _c(
              "div",
              _vm._l(_vm.customerAddressList, function (item, index) {
                return _c(
                  "div",
                  {
                    key: item.id,
                    staticClass: "addressItem",
                    on: {
                      mouseleave: function ($event) {
                        return _vm.hideDeleteButton(index)
                      },
                      mouseover: function ($event) {
                        return _vm.showDeleteButton(index)
                      },
                    },
                  },
                  [
                    _c("div", [
                      _c("span", [
                        _vm._v(
                          _vm._s(item.receiveName || "--") +
                            " / " +
                            _vm._s(item.receiveMobile || "--") +
                            " / " +
                            _vm._s("--") +
                            " / " +
                            _vm._s(item.receiveZipcode || "--")
                        ),
                      ]),
                    ]),
                    _c("div", [
                      _c("span", [
                        _vm._v(
                          _vm._s(item.receiveStreet || "--") +
                            " / " +
                            _vm._s(item.receiveHouseNumber || "--") +
                            " / " +
                            _vm._s(item.receiveCity || "--") +
                            " / " +
                            _vm._s(item.receiveState || "--") +
                            " / " +
                            _vm._s(item.receiveComplement || "--")
                        ),
                      ]),
                    ]),
                    _c("div", [
                      _c("span", [_vm._v(_vm._s(item.receiveAddress || "--"))]),
                    ]),
                    _vm.customerType.type !== "examine"
                      ? _c(
                          "div",
                          {
                            staticClass: "btnOperate1",
                            class: "btnOperate1" + index,
                          },
                          [
                            [
                              _c(
                                "el-popconfirm",
                                {
                                  attrs: {
                                    title: _vm.$t(
                                      "GlobalSetObj.AreYouSureDelete"
                                    ),
                                  },
                                  on: {
                                    confirm: function ($event) {
                                      return _vm.delAddress(item)
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "el-icon-delete",
                                    staticStyle: { color: "#f56c6c" },
                                    attrs: { slot: "reference" },
                                    slot: "reference",
                                  }),
                                ]
                              ),
                            ],
                            _c("i", {
                              staticClass: "el-icon-edit-outline",
                              staticStyle: { color: "#00A551" },
                              on: {
                                click: function ($event) {
                                  _vm.clickSenderDialog(
                                    _vm.$t("customerManagements.editConsignee"),
                                    item
                                  )
                                },
                              },
                            }),
                          ],
                          2
                        )
                      : _vm._e(),
                  ]
                )
              }),
              0
            )
          : _c(
              "div",
              { staticClass: "nodataImage" },
              [_c("svg-icon", { attrs: { "icon-class": "noData" } })],
              1
            ),
      ]),
      _c("el-pagination", {
        staticStyle: { margin: "10px 0", float: "right" },
        attrs: {
          "current-page": _vm.queryForm.pageNumber,
          "page-size": _vm.queryForm.pageSize,
          "page-sizes": [2, 10, 20],
          total: _vm.queryForm.total,
          background: "",
          layout: "total, sizes, prev, pager, next, jumper",
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange,
        },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            "append-to-body": true,
            "close-on-click-modal": false,
            "show-close": true,
            title: _vm.receiveTitleDialog,
            visible: _vm.receiveDialog,
            top: "10vh",
            width: "900px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.receiveDialog = $event
            },
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  ref: "receviceRuleForm",
                  staticClass: "demo-receviceRuleForm",
                  attrs: {
                    model: _vm.receviceRuleForm,
                    inline: "",
                    "label-position": "top",
                  },
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                label: _vm.$t("placeOrder.name"),
                                rules: _vm.checkStr50,
                                prop: "receiveName",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: _vm.$t("placeOrder.pleaseInput"),
                                  clearable: "",
                                  maxlength: "52",
                                },
                                model: {
                                  value: _vm.receviceRuleForm.receiveName,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.receviceRuleForm,
                                      "receiveName",
                                      $$v
                                    )
                                  },
                                  expression: "receviceRuleForm.receiveName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                label: _vm.$t("GlobalSetObj.MobilePhone"),
                                rules: _vm.isPhone,
                                prop: "receiveMobile",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: _vm.$t("placeOrder.pleaseInput"),
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.receviceRuleForm.receiveMobile,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.receviceRuleForm,
                                      "receiveMobile",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "receviceRuleForm.receiveMobile",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                label: _vm.$t("placeOrder.Tax"),
                                rules: _vm.isTax12,
                                prop: "receiveTax",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: _vm.$t(
                                    "newOrder.PleaseEnter12Or14DigitTaxNumber"
                                  ),
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.receviceRuleForm.receiveTax,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.receviceRuleForm,
                                      "receiveTax",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "receviceRuleForm.receiveTax",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                label: _vm.$t("placeOrder.zipcode"),
                                rules: _vm.isZipCode,
                                prop: "receiveZipcode",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  maxlength: 8,
                                  placeholder: _vm.$t("placeOrder.pleaseInput"),
                                  clearable: "",
                                },
                                on: {
                                  blur: function ($event) {
                                    return _vm.zipcodeReceiveChange(
                                      _vm.receviceRuleForm.receiveZipcode
                                    )
                                  },
                                },
                                model: {
                                  value: _vm.receviceRuleForm.receiveZipcode,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.receviceRuleForm,
                                      "receiveZipcode",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "receviceRuleForm.receiveZipcode",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                label: _vm.$t("placeOrder.State"),
                                rules: {
                                  required: true,
                                  message: _vm.$t("placeOrder.pleaseInput"),
                                  trigger: ["blur", "change"],
                                },
                                prop: "receiveState",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "placeOrder.pleaseInput"
                                    ),
                                    clearable: "",
                                  },
                                  on: { change: _vm.stateChangeOption },
                                  model: {
                                    value: _vm.receviceRuleForm.receiveState,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.receviceRuleForm,
                                        "receiveState",
                                        $$v
                                      )
                                    },
                                    expression: "receviceRuleForm.receiveState",
                                  },
                                },
                                _vm._l(_vm.receiveStateList, function (item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: {
                                      label: item.shortName,
                                      value: item.shortName,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                label: _vm.$t("placeOrder.city"),
                                rules: _vm.cityComplement,
                                prop: "receiveCity",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "formTable",
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    disabled:
                                      !_vm.receviceRuleForm.receiveState,
                                    placeholder: _vm.$t(
                                      "placeOrder.pleaseChoose"
                                    ),
                                    "remote-method": _vm.getReceiveCity,
                                    filterable: "",
                                    remote: "",
                                    "reserve-keyword": "",
                                  },
                                  on: {
                                    "visible-change": function ($event) {
                                      return _vm.getReceiveCity()
                                    },
                                  },
                                  model: {
                                    value: _vm.receviceRuleForm.receiveCity,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.receviceRuleForm,
                                        "receiveCity",
                                        $$v
                                      )
                                    },
                                    expression: "receviceRuleForm.receiveCity",
                                  },
                                },
                                _vm._l(_vm.receiveCityList, function (item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: {
                                      label: item.name,
                                      value: item.name,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                label: _vm.$t("placeOrder.Area"),
                                rules: _vm.addressComplement,
                                prop: "receiveArea",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: _vm.$t("placeOrder.pleaseInput"),
                                  clearable: "",
                                  maxlength: "32",
                                },
                                model: {
                                  value: _vm.receviceRuleForm.receiveArea,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.receviceRuleForm,
                                      "receiveArea",
                                      $$v
                                    )
                                  },
                                  expression: "receviceRuleForm.receiveArea",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                label: _vm.$t("newOrder.Street"),
                                prop: "receiveStreet",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: _vm.$t(
                                    "newOrder.ConfirmStreetNumber"
                                  ),
                                  clearable: "",
                                  maxlength: "50",
                                  "show-word-limit": "",
                                },
                                model: {
                                  value: _vm.receviceRuleForm.receiveStreet,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.receviceRuleForm,
                                      "receiveStreet",
                                      $$v
                                    )
                                  },
                                  expression: "receviceRuleForm.receiveStreet",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                label: _vm.$t("placeOrder.HouseNumber"),
                                rules: _vm.checkStr5,
                                prop: "receiveHouseNumber",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: _vm.$t("placeOrder.pleaseInput"),
                                  clearable: "",
                                  maxlength: "6",
                                },
                                model: {
                                  value:
                                    _vm.receviceRuleForm.receiveHouseNumber,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.receviceRuleForm,
                                      "receiveHouseNumber",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "receviceRuleForm.receiveHouseNumber",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                label: _vm.$t(
                                  "GlobalSetObj.NationalRegistrationNumber"
                                ),
                                rules: _vm.IeNumber,
                                prop: "receiveIeNumber",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: _vm.$t("placeOrder.pleaseInput"),
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.receviceRuleForm.receiveIeNumber,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.receviceRuleForm,
                                      "receiveIeNumber",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression:
                                    "receviceRuleForm.receiveIeNumber",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                label: _vm.$t("placeOrder.addressComplement"),
                                rules: _vm.addressComplement,
                                prop: "receiveComplement",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: _vm.$t("placeOrder.pleaseInput"),
                                  clearable: "",
                                  maxlength: "32",
                                },
                                model: {
                                  value: _vm.receviceRuleForm.receiveComplement,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.receviceRuleForm,
                                      "receiveComplement",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "receviceRuleForm.receiveComplement",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                label: _vm.$t("placeOrder.email"),
                                rules: _vm.checkMail,
                                prop: "receiveMail",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: _vm.$t("placeOrder.pleaseInput"),
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.receviceRuleForm.receiveMail,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.receviceRuleForm,
                                      "receiveMail",
                                      $$v
                                    )
                                  },
                                  expression: "receviceRuleForm.receiveMail",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                label: _vm.$t("placeOrder.detailedAddress"),
                                rules: [
                                  {
                                    required: true,
                                    message: _vm.$t("placeOrder.pleaseInput"),
                                    trigger: ["blur", "change"],
                                  },
                                  {
                                    min: 2,
                                    max: 200,
                                    message: _vm.$t(
                                      "newOrder.TdetailedAddressCharacter"
                                    ),
                                    trigger: "blur",
                                  },
                                ],
                                prop: "receiveAddress",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: _vm.$t(
                                    "newOrder.StreetHouseNumber"
                                  ),
                                  clearable: "",
                                  maxlength: "200",
                                  "show-word-limit": "",
                                  type: "text",
                                },
                                model: {
                                  value: _vm.receviceRuleForm.receiveAddress,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.receviceRuleForm,
                                      "receiveAddress",
                                      $$v
                                    )
                                  },
                                  expression: "receviceRuleForm.receiveAddress",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.receiveDialog = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("GlobalSetObj.Cancelar")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.receiveConfirm },
                },
                [_vm._v(_vm._s(_vm.$t("GlobalSetObj.determine")) + " ")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }